export const getDefaultTract = () => {
  return {
    acres: 0,
    cost: 0,
    spot: null,
    businessEntityId: null,
    code: '',
    name: '',
    status: 0,
    mapAndParcelNumber: '',
    certificationIds: [],
    loggerIds: [],
    loggerAccountId: null,
    haulerAccountId: null,
    supplierAccountId: null,
    consultingForesterAccountId: null,
    landOwnerAccountId: null,
    foresterUserId: null,
    teamId: null,
    harvestTypeId: null,
    loggingMethodId: null,
    timberCategoryId: null,
    conversionId: null,
    loggingAccessibilityTagId: null,
    scalingRegion: null,
    permitNumbers: [],
    harvestStartDate: null,
    harvestEndDate: null,
    availabilityStartDate: null,
    availabilityEndDate: null,
    purchaseDate: null,
    requiresExt1: false,
    requiresExt2: false,
    type: {
      tractTypeId: null
    }
  }
}
